import _braintreeError from "./braintree-error";
var exports = {};
var BraintreeError = _braintreeError;
function convertToBraintreeError(originalErr, btErrorObject) {
  if (originalErr instanceof BraintreeError) {
    return originalErr;
  }
  return new BraintreeError({
    type: btErrorObject.type,
    code: btErrorObject.code,
    message: btErrorObject.message,
    details: {
      originalError: originalErr
    }
  });
}
exports = convertToBraintreeError;
export default exports;